import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { AgentsPage } from '@/features/agents/components/AgentsPage'
import type { Agent } from '@/features/agents/types/agent.types'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'

export const Route = createFileRoute('/_auth/agents/')({
  component: AgentsRoute,
})

function AgentsRoute() {
  const navigate = useNavigate()
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink to='/dashboard' className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Agents</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    []
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  const handleViewAgent = (agent: Agent) => {
    navigate({ to: '/agents/$agentId', params: { agentId: agent.id } })
  }

  return (
    <div className='container mx-auto py-6'>
      <AgentsPage onViewAgent={handleViewAgent} />
    </div>
  )
}
